import { render, staticRenderFns } from "./addBind.vue?vue&type=template&id=26ca5e3c&scoped=true&"
import script from "./addBind.vue?vue&type=script&lang=js&"
export * from "./addBind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ca5e3c",
  null
  
)

export default component.exports